export const smallCardIcon = 'https://assets.thdstatic.com/images/v1/payment-credit-card-thd.png';

export const largeCardImage = 'https://assets.thdstatic.com/images/v1/plcc-credit-card.png';

export const DEFAULT_PREQUAL_URL = 'https://citiretailservices.citibankonline.com/CRS/acq/launch/index.action?app=PQ01&'
                                   + 'siteId=PLCN_HOMEDEPOT&sc=30052&cmp=A~H~8~C~8~A~ZZZ0~AI~HD~ZZ_1DT';

export const DEFAULT_APPLYNOW_URL = 'https://citiretailservices.citibankonline.com/CRS/acq/launch/index.action?'
                                    + 'app=UNSOL&siteId=PLCN_HOMEDEPOT&sc=30005&cmp=A~H~8~C~8~A~ZZZ0~AI~HD~ZZ_1DT';

export const smallCardCrc = 'https://assets.thdstatic.com/images/v1/plcc-proxtra-credit-card.png';

export const B2B_DEFAULT_APPLYNOW_URL = 'https://citiretailservices.citibankonline.com/CRS/acq/launch/index.action?'
                                        + 'app=UNSOL&siteId=PLCR_HOMEDEPOT&sc=40012&cmp=A~E~Z~O~3~B~ZZZ0~CR~HD~ZZ_C3T';
export const cardInfoIcon = 'https://assets.thdstatic.com/images/v1/info.svg';
